// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiUrlFlp : 'http://62.171.172.148:8666/maxipan/',
 apiUrl : 'http://192.168.1.9:8881/flp/',
  apiUrlMaxipan : 'http://62.171.172.148:8666/maxipan/',
// apiUrlMaxipan : 'http://62.171.172.148:8666/maxipan_pruebas/',
  apiUrlchat : 'http://localhost:5000',
  //apiUrl : 'http://192.168.1.153:8881/flp/',

};
